<template>
    <!-- Confirm Password -->
    <div class="row">
        <div class="col-sm-12 mb-3" v-if="header">
            <div class="d-flex flex-column gap-3 align-items-center text-center">
                <h3 class="fw-semi-bold m-0">Password Verification</h3>
                <p class="text-secondary m-0">A enter your password for authentication purposes</p>
            </div>
            <div v-if="formErrors.password" class="validation-error mt-0 text-center" v-html="formErrors.password"></div>
        </div>

        <div ref="confirmPasswordForm" class="col-12">
            <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken mb-3" :class="formErrors.password ? 'border-danger' : 'border-secondary'">
	            <label for="password">
		            <i class="me-3 dd-icon bi bi-shield-shaded"></i>
	            </label>
	            <input v-model="password" :type="passwordToggle ? 'text' : 'password'" ref="confirmPasswordField" id="confirmPasswordField" name="password" class="form-control m-0 border-0 fs-5 p-0 lh-fixed" placeholder="Enter Password" autofocus @input="removeFormErrorKey('password')" @keyup.enter="confirmPassword">
                <span class="rounded-circle" v-ripple>
                    <i @click="(event) => passwordToggle = !passwordToggle" :class="passwordToggle ? 'bi-eye' : 'bi-eye-slash'" v-ripple></i>
                </span>
            </div>

            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center">
                <button class="btn btn-outline-secondary rounded-pill py-2 px-3" @click="close">Cancel</button>
                <button v-if="!autoSubmit" class="btn btn-dark rounded-pill py-2 px-3" @click="confirmPassword" :disabled="hasFormErrors">Confirm</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import apiClient from "@/utils/axios.js";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import {useHttpErrorManager} from "@/composables/useHttpErrorManager.js";

const props = defineProps({
	header: { type: Boolean, required: false, default: true },
	autoSubmit: { type: Boolean, required: false, default: false },
	uid: { type: [String, Number, null], required: false, default: null }
});

const emits = defineEmits(['passwordVerificationStatus', 'closePasswordConfirmation']);

const helper = useAppHelpers();
const confirmPasswordForm = ref(null);

const password = ref('');
const passwordToggle = ref(false);
const formErrors = ref({});
const confirmPasswordField = ref(null);
onMounted(() => {
	setTimeout(() => {
		confirmPasswordField.value.focus();
	}, 400);
});

const removeFormErrorKey = (key) => {
    delete formErrors.value[key];
};

const hasFormErrors = computed(() => {
    return Object.keys(formErrors.value).length > 0;
});

const passwordVerified = ref(false);
const confirmPassword = async () => {
    helper.loaderOn(confirmPasswordForm.value);

    if (!password.value || (password.value && password.value.trim() === '')) {
        formErrors.value.password = 'Password is required.';
        helper.loaderOff(confirmPasswordForm.value);
        return;
    }

	let data = {
		password: password.value
	}
	if (props.uid) {
		data.uid = props.uid;
		data.access = 'restricted';
	}

    try {
        const response = await apiClient.post('auth/user/confirmPassword', data);

        if (response.status >= 200 && response.status < 300) {
            passwordVerified.value = true;
	        emits('passwordVerificationStatus', passwordVerified.value);
        }
	    // helper.loaderOff(confirmPasswordForm.value);
    }
    catch (error) {
        helper.loaderOff(confirmPasswordForm.value);
        let errorObj = await useHttpErrorManager().handleError(error);
        if (error.response.status === 422) {
            formErrors.value = errorObj;
	        removeFormErrorKey('full_message');
            removeFormErrorKey('alt_message');
            removeFormErrorKey('err_message');
        }
        passwordVerified.value = false;
	    emits('passwordVerificationStatus', passwordVerified.value);
    }
}

const close = async () => {
    emits('passwordVerificationStatus', passwordVerified.value);
	emits('closePasswordConfirmation');
}

defineExpose({
    close
});
</script>
